import { z } from "zod";

import { personalizationSeveritySchema } from "@/types/backoffice/dto/personalization/personalization-severity-dto.ts";
import { personalizationSupportTypeSchema } from "@/types/backoffice/dto/personalization/personalization-support-type-dto.ts";

export const applyPersonalizationRequestSchema = z.object({
  comment: z.string().min(1),
  csLinkIds: z.array(z.number()).nullable(),
  severity: personalizationSeveritySchema,
  supportType: personalizationSupportTypeSchema,
});

export type TApplyPersonalizationRequestSchema = z.infer<typeof applyPersonalizationRequestSchema>;
